import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { registerMicroApps, start } from 'qiankun';
import '@/permission' // permission control
import hasPermission from '@/utils/hasPermission'
import Storage from 'vue-ls'
import { initFunc, getFrontConfig, utils, services, directives } from 'ow-service-component'
import {ACCESS_TOKEN, ACCESS_SECRET, USER_HALL_INFO} from "@/store/mutation-types"
import "@/utils/directive.js"

// element 按需引入
import {
  Button,
  Select,
  Input,
  Form,
  FormItem,
  Link,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Message,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  DatePicker,
  Table,
  TableColumn,
  Option,
  Pagination,
  Tabs,
  TabPane,
  Upload,
  MessageBox,
  Dialog,
  Popover
} from 'element-ui';

Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Link);
Vue.use(Checkbox);
Vue.use(CheckboxButton);
Vue.use(CheckboxGroup);
// Vue.use(Message);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(DatePicker);
Vue.use(Option);
Vue.use(Table);
Vue.use(TableColumn)
Vue.use(Pagination)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Upload)
Vue.use(Popover)
Vue.use(Dialog);

Vue.component(Button.name, Button);
Vue.component(Select.name, Select);
Vue.component(MessageBox.name, MessageBox);
Vue.use(hasPermission)
Vue.use(Storage, {
  namespace: 'pro__', // key prefix
  name: 'ls', // name variable Vue.[ls] or this.[$ls],
  storage: 'local', // storage name session, local, memory
})

Vue.prototype.$message = Message;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.config.productionTip = false

// 埋点工具
Vue.use(directives.track)

directives.track.configTrack({
  getToken() {
    return Vue.ls.get(ACCESS_TOKEN)
  },
  getSecret() {
    return Vue.ls.get(ACCESS_SECRET)
  },
  actionSys: 'guideWeb2.0',
  paramFuncArr: [
    () => {
      let hallId = ''
      if (Vue.ls.get(USER_HALL_INFO)) {
        hallId = Vue.ls.get(USER_HALL_INFO).id
      }
      return { hallId }
    }
  ]
})

initFunc().then(async () => {
  console.log('front config', getFrontConfig())
  let ticket = utils.commonUtils.getUrlKey('ticket')
  if (ticket) {
    try {
      let ticketValRet = await services.impl.login.validateTicket(ticket)
      console.log(ticketValRet)
      Vue.ls.set(ACCESS_TOKEN, ticketValRet.token)
      Vue.ls.set(ACCESS_SECRET, ticketValRet.secret)
    } catch (ex) {
      console.warn('invalid ticket', ticket)
    }
  }
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
  registerMicroApps([
    {
      name: 'GovernmentGuideWeb',
      // entry: 'http://localhost:8080/guideweb/', // 如果子应用添加了publicpath
      // entry: getFrontConfig().GUIDE_CENTER_URL,  // 测试
      entry: process.env.CONFIG_REGISTER_URL || getFrontConfig().GUIDE_CENTER_URL, // 正式 该地址为命令行输入的子应用链接地址或frontconfig中地址
      container: '#appContainer',
      activeRule: `${__webpack_public_path__}subApplication/GovernmentGuideWeb`,
      props: { data: { store } }
    }
  ])
})


// start();
